import React, { useMemo } from 'react';

// Lightweight, dependency-free confetti overlay (theme colors).
const COLORS = ['#e3b23c', '#f0cd6e', '#ffffff', '#c9962b', '#fff2cc'];

export default function Confetti({ count = 150 }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const round = Math.random() > 0.6;
        const size = 6 + Math.random() * 9;
        return {
          i,
          left: Math.random() * 100,
          delay: Math.random() * 0.5,
          duration: 2.2 + Math.random() * 1.8,
          size,
          height: round ? size : size * 1.7,
          color: COLORS[i % COLORS.length],
          drift: (Math.random() * 2 - 1) * 140,
          rot: (Math.random() * 4 + 1) * 360 * (Math.random() > 0.5 ? 1 : -1),
          radius: round ? '50%' : '2px',
        };
      }),
    [count]
  );

  return (
    <div className="confetti-overlay" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.i}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.height}px`,
            background: p.color,
            borderRadius: p.radius,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            '--drift': `${p.drift}px`,
            '--rot': `${p.rot}deg`,
          }}
        />
      ))}
    </div>
  );
}
